import { Component, computed, input, output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TNil } from '@app/app.interface';
import { TranslateModule } from '@ngx-translate/core';
import { ICampaignCreatorForm, ICtaForm } from '@pages/campaigns/campaign-form/campaign-form.interface';
import { IconComponent } from '@shared/components/icon/icon.component';
import { IconBadgeComponent } from '../icon-badge/icon-badge.component';

@Component({
  imports: [IconComponent, IconBadgeComponent, MatButtonModule, MatTooltipModule, TranslateModule],
  selector: 'app-custom-creator-badge',
  templateUrl: './custom-creator-badge.component.html',
})
export class CustomCreatorBadgeComponent {
  public readonly existingCtaForm = input<FormGroup<ICtaForm> | null>(null);
  public readonly campaignCreatorsValue = input.required<FormArray<FormGroup<ICampaignCreatorForm>>['value']>();
  public readonly creatorId = input.required<string | TNil>();

  public readonly customModeDisabled = output<void>();

  public readonly creator = computed(() => {
    return this.campaignCreatorsValue().find((cc) => cc.creator?.id === this.creatorId())?.creator;
  });

  public disableCustomMode(): void {
    this.customModeDisabled.emit();
  }
}
